<template>
  <div style="height: 100%  ">
    <v-card style="border-radius: 10px;height:100%">
      <v-row no-gutters class="pa-4 desktop-left-panel">
        <span>{{ $t(`label.welcomeBack`) }}</span>
        <v-col cols="12">
          <div class="grey-card">
            <v-row no-gutters class="pa-3 card-row">
              <img src="/static/svg/account-grey2.svg" class="left-panel-icon mr-2" />
              <span class="panel-blue-text">{{ isLoggedIn ? (memberInfo ? memberInfo.memberCode : '') : '' }}</span>
            </v-row>
          </div>
        </v-col>

        <v-col cols="12">
          <div class="grey-card">
            <v-row no-gutters class="pa-3 card-row">
              <img src="/static/svg/bettingPass-grey.svg" class="left-panel-icon mr-2" />
              <v-col>
                <span class="mr-1">{{ $t(`mobileMenuTitle.bettingPass`) }}</span>
                <span class="panel-blue-text">{{ $t(`label.level`) }} {{ isLoggedIn ? vipProgressLevel : 0 }}</span>
              </v-col>
              <v-col cols="12" class="mt-2">
                <v-progress-linear rounded :indeterminate="isProgressLoading" color="yellow" background-color="grey" :value="isLoggedIn ? progressValue : 0"></v-progress-linear>
              </v-col>
              <v-col cols="12" class="mt-1">
                <span v-if="isLoggedIn" class="progress-text">{{ vipProgress ? vipProgress.current_deposit_progress + '/' + vipProgress.required_deposit_amount : '' }}</span>
                <span v-else class="progress-text">{{ '0 / 0' }}</span>
              </v-col>
            </v-row>
          </div>

          <!--viptier progress-->
          <div class="grey-card">
            <v-row no-gutters class="pa-3 card-row" v-if="currentCurrency.toUpperCase() != 'PKR'">
              <v-col cols="4" v-if="memberVipTierProgress && memberVipTierProgress.image"><img :src="`${memberVipTierProgress.image}`" class="left-panel-icon mr-2" /></v-col>
              <v-col cols="4" v-else><img :src="mediaUrl + '/vipTier/newMember.png'" class="left-panel-icon mr-2" /></v-col>
              <v-col>
                <span class="mr-1">{{ $t(`label.vipTier`) }}</span>
                <span v-if="isLoggedIn" class="panel-blue-text">{{ currentLevel }}</span>
                <span v-else class="panel-blue-text">0</span>
              </v-col>
              <v-col cols="12" class="mt-2">
                <v-progress-linear rounded :indeterminate="isProgressLoading" color="yellow" background-color="grey" :value="isLoggedIn ? 100 : 0"></v-progress-linear>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-row no-gutters v-if="isLoggedIn">
                  <v-col cols="12" class="pa-0">
                    <span class="progress-text">{{ $t(`label.deposit`) }} : {{ $t(`label.completed`) }}</span>
                  </v-col>
                </v-row>
                <span v-else class="progress-text">{{ '0 / 0' }}</span>
              </v-col>
              <v-col cols="12" class="mt-2">
                <v-progress-linear rounded :indeterminate="isProgressLoading" color="yellow" background-color="grey" :value="isLoggedIn ? vipTierTurnoverProgressPercent : 0"></v-progress-linear>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-row no-gutters v-if="isLoggedIn">
                  <v-col cols="12" class="pa-0">
                    <span class="progress-text">{{ $t(`label.turnover`) }} : {{ progressTurnoverLabel }}</span>
                  </v-col>
                </v-row>
                <span v-else class="progress-text">{{ '0 / 0' }}</span>
              </v-col>
            </v-row>
          </div>

          <!--          <div class="grey-card">-->
<!--            <v-row no-gutters class="pa-3 card-row">-->
<!--              <img v-if="isLoggedIn && memberVipTierProgress && memberVipTierProgress.image" :src="`${memberVipTierProgress.image}`" class="left-panel-icon mr-2" />-->
<!--              <img v-else :src="mediaUrl + '/vipTier/newMember.png'" class="left-panel-icon mr-2" />-->
<!--              <v-col>-->
<!--                <span v-if="isLoggedIn" class="mr-1 text-uppercase">{{ $t(`label.vipText`) }} {{ currentLevel }}</span>-->
<!--                <span v-else class="mr-1 text-uppercase">{{ $t(`label.vipText`) }} {{ $t(`label.newMember`) }}</span>-->
<!--              </v-col>-->
<!--              <v-col cols="12" class="mt-2">-->
<!--                <v-progress-linear rounded :indeterminate="isProgressLoading" color="yellow" background-color="grey" :value="isLoggedIn ? vipTierProgressPercent : 0"></v-progress-linear>-->
<!--              </v-col>-->
<!--              <v-col cols="12" class="mt-1">-->
<!--                <span v-if="isLoggedIn" class="progress-text">{{ progressLabel }}</span>-->
<!--                <span v-else class="progress-text">{{ '0 / 0' }}</span>-->
<!--              </v-col>-->
<!--            </v-row>-->
<!--          </div>-->
        </v-col>
        <v-col cols="12">
          <v-divider class="my-3"></v-divider>
        </v-col>
        <v-col cols="12">
          <div class="grey-card">
            <v-row no-gutters class="pa-3 card-row">
              <v-col class="g-text" cols="12">
                <span>{{ $t(`label.coinsRewards`) }}</span>
              </v-col>
              <v-col class="g-text" cols="12">
                <span class="panel-blue-text">{{ isLoggedIn ? (memberInfo ? memberInfo.rewardBalance : '') : 0 }}</span>
              </v-col>
              <v-col cols="12" class="mt-2">
                <v-btn class="nav-btn" @click="goToRewards">
                  {{ $t(`label.goToRewards`) }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="grey-card">
            <v-row no-gutters class="pa-3 card-row">
              <v-col class="g-text" cols="12">
                <span>{{ $t(`label.referralWallet`) }}</span>
              </v-col>
              <v-col class="g-text" cols="12">
                <span v-if="isLoggedIn" class="panel-blue-text">{{ redeemCommissionAmt | currency(currentCurrency) }}</span>
                <span v-else class="panel-blue-text">{{ 0 | currency(currentCurrency) }}</span>
              </v-col>
              <v-col cols="12" class="mt-2">
                <v-btn class="nav-btn" @click="redeemCommissionConfirmationDialog">
                  {{ $t(`button.redeem`) }}
                </v-btn>
              </v-col>
              <v-col cols="12" class="mt-2">
                <p style="font-size: .80rem">{{ $t(`message.bankLeftPane_referralWalletDesc`) }}</p>
              </v-col>
              <v-col cols="12" class="mt-2">
                <!--                <v-text-field solo-inverted v-model.trim="referralOverview.my_referral_code" :readonly="true"></v-text-field>-->
                <div class="share-div" v-if="isLoggedIn">
                  <div class="referralCode-div" style="">
                    <span class="grey-text-field ref-text panel-blue-text pa-2">{{ referralOverview.my_referral_code }}</span>
                  </div>
                  <div class="share-btn-div">
                    <v-btn icon class="share-btn" @click="share">
                      <!--                      <v-icon class="share-icon">mdi-share-outline</v-icon>-->
                      <img src="/static/svg/share-outline.svg" />
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { DevicePlatform } from '@/constants/enums'
import { ROUTE_NAME } from '@/constants/route.constants'
import { errorCodeHelper, locale, uiHelper } from '@/util'
import AccountBank from '@/assets/svg/profile/bank.svg'
import AccountDeposit from '@/assets/svg/profile/deposit.svg'
import AccountHistory from '@/assets/svg/profile/history.svg'
import AccountInbox from '@/assets/svg/profile/inbox.svg'
import AccountPassword from '@/assets/svg/profile/password.svg'
import AccountProfile from '@/assets/svg/profile/profile.svg'
import AccountReward from '@/assets/svg/profile/reward.svg'
import AccountVip from '@/assets/svg/profile/vip.svg'
import AccountWithdrawal from '@/assets/svg/profile/withdrawal.svg'
import { AFFILIATE_ONE_TIME_BONUS_DETAIL } from '@/store/affiliate.bonus.module'
import { REFERRAL_POST_COMMISSION, REFERRAL_RESET_COMMISSION } from '@/store/referral.module'
import stringFormat from 'string-format'
import { SHARED } from '@/constants/constants'
import { MEMBER_VIP_TIER_PROGRESS } from '@/store/member.module'
export default {
  name: 'appBankAndProfileSidePanel',
  components: {
    AccountBank,
    AccountDeposit,
    AccountHistory,
    AccountInbox,
    AccountPassword,
    AccountProfile,
    AccountReward,
    AccountVip,
    AccountWithdrawal
  },
  data: () => ({
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    currentLevel: 'member',
    viptierCurLevel: -1,
    progressLabel: '',
    progressTurnoverLabel: '',
    currentUpgradeTurnover: 0,
    requiredUpgradeTurnover: 0,
    vipTierTurnoverProgressPercent: 0,
    currentUpgradeDeposit: 0,
    requiredUpgradeDeposit: 0,
    stringFormat: stringFormat,
    currentCurrency: uiHelper.getCurrency(),
    share_url: '',
    redeemCommissionAmt: 0,
    progressValue: 0,
    vipTierProgressValue: 0,
    vipTireDepositProgress: 0,
    vipTierProgressPercent: 0,
    isProgressLoading: true,
    vipProgressLevel: 0,
    vipTierProgressLevel: 0,
    devicePlatform: DevicePlatform,
    uihelper: uiHelper,
    openNav: false,
    routeName: ROUTE_NAME,
    bankLink: [
      {
        text_key: 'deposit',
        routeName: ROUTE_NAME.DEPOSIT
      },
      {
        text_key: 'withdrawal',
        routeName: ROUTE_NAME.WITHDRAWAL
      },
      {
        text_key: 'transfer',
        routeName: ROUTE_NAME.TRANSFER
      },
      {
        text_key: 'history',
        routeName: ROUTE_NAME.TRANSACTION_HISTORY
      },
      {
        text_key: 'turnover',
        routeName: ROUTE_NAME.TURNOVER
      },
      {
        text_key: 'player-history',
        routeName: ROUTE_NAME.PLAYER_HISTORY
      },
      {
        text_key: 'bankAccount',
        routeName: ROUTE_NAME.BANK_ACCOUNT
      }
    ],
    profileLink: [
      {
        text_key: 'account',
        routeName: ROUTE_NAME.PROFILE
      },
      {
        text_key: 'personal',
        routeName: ROUTE_NAME.PERSONAL
      },
      {
        text_key: 'announcement',
        routeName: ROUTE_NAME.ANNOUNCEMENT
      },
      {
        text_key: 'referral',
        routeName: ROUTE_NAME.AFFILIATE_REFERRAL
      }
    ],
    affiliateLink: [
      {
        text_key: 'qrCode',
        routeName: ROUTE_NAME.AFFILIATE_LINK
      },
      {
        text_key: 'withdrawal',
        routeName: ROUTE_NAME.AFFILIATE_WITHDRAWAL
      },
      {
        text_key: 'history',
        routeName: ROUTE_NAME.AFFILIATE_TRANSACTION
      },
      {
        text_key: 'bankAccount',
        routeName: ROUTE_NAME.AFFILIATE_BANK_ACCOUNT
      }
    ],
    vipTierImages: [
      { id: 1, src: SHARED.MEDIA_SERVER_URL + '/vipTier/newMember.png', name: 'newMember' },
      { id: 2, src: SHARED.MEDIA_SERVER_URL + '/vipTier/premium.png', name: 'premium' },
      { id: 3, src: SHARED.MEDIA_SERVER_URL + '/vipTier/royalAce.png', name: 'royalAce' },
      { id: 4, src: SHARED.MEDIA_SERVER_URL + '/vipTier/legendary.png', name: 'legendary' },
      { id: 5, src: SHARED.MEDIA_SERVER_URL + '/vipTier/imperial.png', name: 'imperial' },
      { id: 6, src: SHARED.MEDIA_SERVER_URL + '/vipTier/titan.png', name: 'titan' }
    ]
  }),
  created() {
    if (this.vipProgress && this.vipProgress.required_deposit_amount >= 0 && this.vipProgress.current_deposit_progress >= 0) {
      this.progressValue = (this.vipProgress.current_deposit_progress / this.vipProgress.required_deposit_amount) * 100
      this.vipProgressLevel = this.vipProgress.current_level_name.indexOf('Level') != -1 ? this.vipProgress.current_level_name.split(' ')[1] : ''
    }

    if (this.vipTierProgress && this.vipTierProgress.required_deposit_amount >= 0 && this.vipTierProgress.current_deposit_progress >= 0) {
      this.vipTierProgressValue = (this.vipTierProgress.current_deposit_progress / this.vipTierProgress.required_deposit_amount) * 100
      this.isProgressLoading = false
      this.vipTierProgressLevel = this.vipTierProgress.current_level_name.indexOf('Level') != -1 ? this.vipTierProgress.current_level_name.split(' ')[1] : ''
    }

    this.getVipTierProgress()
    this.setVipTierLevel()

    if (!_.isEmpty(this.referralOverview)) {
      this.share_url = uiHelper.getHostname() + '?refer_code=' + this.referralOverview.my_referral_code
      this.redeemCommissionAmt = this.$store.state.referral.overview.commission_balance.toFixed(2)
    }
  },
  computed: {
    vipTierDowngrade() {
      return this.$store.state.member.vipTierProgress.downgrade
    },
    vipTierUpgrade() {
      return this.$store.state.member.vipTierProgress.upgrade
    },
    memberVipTierProgress() {
      return this.$store.state.member.vipTierProgress.pairing
    },
    watchVipCurLevel() {
      return this.viptierCurLevel
    },
    // navPermanent() {
    //   if($vuetify.breakpoint.mdAndDown)
    //     return false
    // }
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    affiliateBonus() {
      return this.$store.state.affiliateBonus.affiliateBonusDetail
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    vipProgress() {
      return this.$store.state.member.vipProgress
    },
    referralOverview() {
      return this.$store.state.referral.overview
    },
    redeemCommissionDetailResponseComplete() {
      return this.$store.state.referral.redeemCommissionResponse.complete
    },
    webShareApiSupported() {
      return navigator.share
    },
    vipTierProgress() {
      return this.$store.state.member.iplVipProgress
    }
  },
  watch: {
    watchVipCurLevel() {
      this.setVipTierDetails()
    },
    memberVipTierProgress() {
      this.setVipTierLevel()
    },
    referralOverview() {
      this.share_url = uiHelper.getHostname() + '?refer_code=' + this.referralOverview.my_referral_code
      this.redeemCommissionAmt = this.$store.state.referral.overview.commission_balance.toFixed(2)
    },
    redeemCommissionDetailResponseComplete() {
      let response = this.$store.state.referral.redeemCommissionResponse
      if (response.complete) {
        this.redeemCommissionResponseCompleteDialog(response)
        this.$store.dispatch(`${REFERRAL_RESET_COMMISSION}`)
      }
    },
    isLoggedIn() {
      this.getAffiliateBonusDetail()
      this.getVipTierProgress()
    },
    vipProgress() {
      this.isProgressLoading = false
      let progress = this.$store.state.member.vipProgress
      if (progress && progress.required_deposit_amount && progress.current_deposit_progress) {
        this.progressValue = (progress.current_deposit_progress / progress.required_deposit_amount) * 100
        this.vipProgressLevel = progress.current_level_name.indexOf('Level') != -1 ? progress.current_level_name.split(' ')[1] : ''
      }
    },
    vipTierProgress() {
      let progress = this.$store.state.member.iplVipProgress
      if (progress && progress.required_deposit_amount && progress.current_deposit_progress) {
        this.vipTierProgressValue = (progress.current_deposit_progress / progress.required_deposit_amount) * 100
        this.vipTierProgressLevel = progress.current_level_name.indexOf('Level') != -1 ? progress.current_level_name.split(' ')[1] : ''
      }
    }
  },
  methods: {
    setVipTierLevel() {
      if (this.memberVipTierProgress && this.memberVipTierProgress.level_sequence != undefined) {
        this.viptierCurLevel = this.memberVipTierProgress.level_sequence
        this.currentLevel = this.memberVipTierProgress.name
        console.log('reach here')
        console.log(this.memberVipTierProgress)
      }
    },
    setVipTierDetails() {
      if (this.viptierCurLevel >= 0 && this.viptierCurLevel < 6) {
        if (this.vipTierUpgrade) {
          if (this.vipTierUpgrade.required_upgrade_deposit && this.vipTierUpgrade.required_upgrade_deposit >= 0) {
            this.requiredUpgradeDeposit = Number(this.vipTierUpgrade.required_upgrade_deposit)
            this.requiredUpgradeTurnover = Number(this.vipTierUpgrade.required_upgrade_turnover)
          }

          if (this.vipTierUpgrade.current_upgrade_deposit && this.vipTierUpgrade.current_upgrade_deposit >= 0) {
            this.currentUpgradeDeposit = Number(this.vipTierUpgrade.current_upgrade_deposit)
            this.currentUpgradeTurnover = Number(this.vipTierUpgrade.current_upgrade_turnover)
          }
          this.progressLabel = this.currentUpgradeDeposit.toString() + '/' + this.requiredUpgradeDeposit.toString()
          this.progressTurnoverLabel = this.currentUpgradeTurnover.toLocaleString() + '/' + this.requiredUpgradeTurnover.toLocaleString()
        } else {
          if (this.vipTierUpgrade == null) {
            //pending upgrade tier
            this.progressLabel = locale.getMessage(`label.vipTierPendingUpgrade`)
          }
        }
      } else {
        ///highest tier level in automation = 6 , level 7 is manual upgrade rquired
        if (this.vipTierDowngrade) {
          if (this.vipTierDowngrade.required_downgrade_deposit && this.vipTierDowngrade.required_downgrade_deposit >= 0) {
            this.requiredUpgradeDeposit = Number(this.vipTierDowngrade.required_downgrade_deposit)
            this.requiredUpgradeTurnover = Number(this.vipTierUpgrade.required_upgrade_turnover)
          }

          if (this.vipTierDowngrade.current_downgrade_deposit && this.vipTierDowngrade.current_downgrade_deposit >= 0) {
            this.currentUpgradeDeposit = Number(this.vipTierDowngrade.current_downgrade_deposit)
            this.currentUpgradeTurnover = Number(this.vipTierUpgrade.current_upgrade_turnover)
          }
          this.progressLabel = this.currentUpgradeDeposit.toString() + '/' + this.requiredUpgradeDeposit.toString()
          this.progressTurnoverLabel = this.currentUpgradeTurnover.toLocaleString() + '/' + this.requiredUpgradeTurnover.toLocaleString()
        } else {
          //check for whether retention fulfilled
          if (this.vipTierDowngrade == null && this.vipTierUpgrade == null) {
            this.progressLabel = locale.getMessage(`label.vipTierRetentionFulFilled`)
          }
        }
      }

      if (this.requiredUpgradeDeposit > 0) {
        this.vipTierProgressPercent = Math.ceil((this.currentUpgradeDeposit / this.requiredUpgradeDeposit) * 100)
      } else {
        //assume Denominator = 0 mean no need to upgrade / fulfilled
        //either retention fulfilled or pending upgrade
        this.vipTierProgressPercent = 100
      }
      if (this.requiredUpgradeTurnover > 0) {
        this.vipTierTurnoverProgressPercent = Math.ceil((this.currentUpgradeTurnover / this.requiredUpgradeTurnover) * 100)
      } else {
        this.vipTierTurnoverProgressPercent = 100
      }

      //regarding upgrade/downgrade is null or not as long we 100% then display fulfillment message
      if (this.vipTierProgressPercent === 100) {
        if (this.viptierCurLevel < 6) {
          this.progressLabel = locale.getMessage(`label.vipTierPendingUpgrade`)
        } else {
          this.progressLabel = locale.getMessage(`label.vipTierRetentionFulFilled`)
        }
      }
      if (this.vipTierTurnoverProgressPercent === 100) {
        if (this.viptierCurLevel < 6) {
          this.progressTurnoverLabel = locale.getMessage(`label.completed`)
        } else {
          this.progressTurnoverLabel = locale.getMessage(`label.completed`)
        }
      }
    },
    getVipTierProgress() {
      if (this.isLoggedIn) {
        this.$store.dispatch(MEMBER_VIP_TIER_PROGRESS)
      }
    },
    redeemCommissionResponseCompleteDialog(response) {
      this.closePageDialog()
      if (response.code != 0 && !response.success) {
        this.$parent.openAlert(false, errorCodeHelper.getErrorCodeDesc(response.code))
      } else {
        this.$parent.openAlert(true, locale.getMessage(`message.commissionRedeemSuccess`))
      }
    },
    getAffiliateBonusDetail() {
      this.$store.dispatch(`${AFFILIATE_ONE_TIME_BONUS_DETAIL}`)
    },
    goToRewards() {
      this.$router.push({ name: ROUTE_NAME.REWARDS, params: { lang: this.$route.params.lang } })
    },
    redeemCommissionConfirmationDialog() {
      let self = this

      if (this.redeemCommissionAmt) {
        let dialog = this.initializePageDialogProperty()
        dialog.title = locale.getMessage(`label.redeemConfirmation`)
        dialog.message.push(this.stringFormat(locale.getMessage(`message.ConfirmCommission`), self.$options.filters.currency(this.redeemCommissionAmt, this.currentCurrency)))
        dialog.button.push({
          title: locale.getMessage(`label.confirm`),
          action: () => this.redeemCommission()
        })
        this.openPageDialog(dialog)
      }
    },
    redeemCommission() {
      let obj = { amount: this.redeemCommissionAmt }
      this.$store.dispatch(`${REFERRAL_POST_COMMISSION}`, {
        obj
      })
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closePageDialog() {
      this.$eventHub.$emit('close-page-dialog', true)
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    share() {
      const sharing = {
        title: 'Refer a friend now and earn commission',
        text: 'Your referral code is ' + this.referralOverview.my_referral_code + '.Refer a friend now and earn commission now! ',
        url: this.share_url
      }
      if (this.webShareApiSupported) {
        navigator.share(sharing)
      } else {
        let $f = this
        this.$copyText(this.share_url).then(function(e) {
          $f.alertMessage = 'Referral Link Copied!'
          $f.alertSuccess = true
          $f.alertShow = true
        })
      }
    },
    getVipTierImage(level) {
      const image = this.vipTierImages.find(image => image.id === parseInt(level))
      return image ? image.src : ''
    }
  }
}
</script>

<style lang="scss">
.g-text {
  font-size: 15px;
}
.ref-text {
  font-size: 14px;
}
.desktop-left-panel {
  border-radius: 10px;
  //height: 660px;
  overflow-y: auto;

  .grey-card {
    background-color: #f3f5f6 !important;
    border: unset !important;
    margin-top: 8px;
    border-radius: 10px;
    font-size: 0.83rem;

    .card-row {
      align-items: center;
      font-size: 0.81rem;
    }
    .v-progress-linear__determinate {
      background-color: var(--v-newMobilePrimary-base) !important;
    }
    .v-progress-linear__background {
      background-color: #d9d9d9 !important;
    }

    .nav-btn {
      font-size: 0.7rem;
      width: 100%;
      border-radius: 20px;
      color: white;
      background-color: var(--v-newMobilePrimary-base);

      & span {
        width: 100%;
        text-wrap: wrap;
      }
    }
  }

  .panel-blue-text {
    color: var(--v-newMobileSecondary-base) !important;
  }

  .share-div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 5px 5px;

    .referralCode-div {
      width: 75%;
    }

    .share-btn-div {
      //flex-basis: 20%;
      width: 20%;
    }
  }
  .grey-text-field {
    background-color: #d9d9d9;
    border-radius: 10px;
    width: 100%;
    display: inline-block;
  }

  .left-panel-icon {
    width: 30px;
    height: 30px;
  }

  .share-btn {
    background-color: var(--v-newMobileSecondary-base);
    border-radius: 10px;
    width: 100%;
    height: 36px;
    .share-icon {
      width: 20px;
      height: 20px;
    }
  }
}

.desktop-navigation-drawer {
  font-size: 12px;
  border-radius: 20px;
  height: 660px;
  .nav-title {
    color: #acacac;
  }
  .profile-nav-button {
    .mobile-icon {
      fill: #3a3a3a;
      path {
        fill: #3a3a3a;
      }
    }
    .mobile-icon-deposit {
      fill: #3a3a3a !important;
    }
    // &:hover {
    //   color: #0C2AAB !important;
    //   .mobile-icon {
    //     fill: #0C2AAB !important;
    //     path {
    //       fill: #0C2AAB !important;
    //     }
    //   }
    //   .mobile-icon-deposit{
    //     fill: #0C2AAB !important;
    //   }
    // }
  }

  .nav-btn.theme--light.v-list-item--active::before {
    opacity: 0 !important;
  }
}
.profile-nav-active {
  background-color: #3a3a3a !important;
  color: #fff !important;
  .mobile-icon {
    fill: #fff !important;
    path {
      fill: #fff !important;
    }
  }
}

@media (max-width: 1590px) {
  .grey-card {
    .v-btn.v-size--default {
      font-size: 0.7rem !important;
    }
  }
}

@media (max-width: 1271px) {
  .share-div {
    .referralCode-div {
      //flex-basis: 100% !important;
    }
    .share-btn-div {
      //flex-basis: 100% !important;

      .share-btn {
        width: 100% !important;
        flex-basis: 100% !important;
      }
    }
  }
}
</style>
